export default {
    title: 'Προστασία στοιχείων',
    sidebar: 'Προστασία στοιχείων',

    description: {
        what: 'Προσθέστε ένα επιπλέον επίπεδο ασφάλειας σε ευαίσθητα τμήματα του λογαριασμού σας, όπως τα οικονομικά στοιχεία.',
        how: 'Μόλις ενεργοποιηθεί, θα σας ζητηθεί να εισάγετε ένα σύντομο PIN πριν αποκτήσετε πρόσβαση σε προστατευμένες περιοχές. Οι συνεδρίες διαρκούν 15 λεπτά πριν απαιτηθεί εκ νέου πιστοποίηση.',
        note: 'Το PIN είναι ξεχωριστό από τον κωδικό του λογαριασμού σας και έχει σχεδιαστεί για γρήγορο έλεγχο πρόσβασης — για παράδειγμα, για αποτροπή μη εξουσιοδοτημένης προβολής όταν απομακρυνθείτε από τον υπολογιστή σας.',
    },

    set: {
        passcode: 'PIN',
        placeholder: 'Εισάγετε PIN (τουλ. 4 χαρακτήρες)',
        confirm: 'Επιβεβαίωση PIN',
        confirmPlaceholder: 'Επαναλάβετε το PIN σας',
        submit: 'Ορισμός PIN',
        success: 'Το PIN ορίστηκε επιτυχώς.',
    },

    change: {
        title: 'Αλλαγή PIN',
        subtitle: 'Ενημερώστε το υπάρχον PIN σας.',
        currentPasscode: 'Τρέχον PIN',
        newPasscode: 'Νέο PIN',
        confirmPasscode: 'Επιβεβαίωση νέου PIN',
        placeholders: {
            current: 'Εισάγετε το τρέχον PIN σας',
            new: 'Εισάγετε το νέο PIN σας (τουλ. 4 χαρακτήρες)',
            confirm: 'Επαναλάβετε το νέο PIN σας',
        },
        submit: 'Αλλαγή PIN',
        success: 'Το PIN άλλαξε επιτυχώς.',
        incorrect: 'Το τρέχον PIN είναι λανθασμένο.',
    },

    remove: {
        description: 'Για λόγους ασφαλείας, ένας σύνδεσμος αφαίρεσης θα σταλεί στο email σας.',
        submit: 'Αίτημα αφαίρεσης',
        success: 'Ένας σύνδεσμος αφαίρεσης στάλθηκε στο email σας.',
    },

    removal: {
        title: 'Αφαίρεση PIN',
        processing: 'Αφαίρεση του PIN σας...',
        success: 'Το PIN σας αφαιρέθηκε επιτυχώς.',
        expired: 'Αυτός ο σύνδεσμος αφαίρεσης έχει λήξει. Ζητήστε νέο από τις ρυθμίσεις σας.',
        invalid: 'Αυτός ο σύνδεσμος αφαίρεσης δεν είναι έγκυρος.',
        backToSettings: 'Πίσω στις ρυθμίσεις',
    },

    gate: {
        title: 'Αυτή η ενότητα είναι κλειδωμένη',
        subtitle: 'Εισάγετε το PIN σας για να δείτε αυτό το περιεχόμενο.',
        goToSettings: 'Μετάβαση στις ρυθμίσεις',
        sessionExpired: 'Η συνεδρία σας έληξε',
    },

    session: {
        protectedSection: 'Προστατευμένη συνεδρία',
        remaining: 'απομένουν',
        lockNow: 'Κλείδωμα',
    },

    modal: {
        placeholder: 'Εισάγετε το PIN σας',
        submit: 'Ξεκλείδωμα',
        incorrect: 'Το PIN που εισάγατε είναι λανθασμένο.',
        forgot: 'Ξεχάσατε το PIN;',
    },

    validation: {
        minLength: 'Το PIN πρέπει να είναι τουλάχιστον 4 χαρακτήρες.',
        mismatch: 'Τα PIN δεν ταιριάζουν.',
    },

    status: {
        enabled: 'Η προστασία PIN είναι ενεργή',
        enabledDescription: 'Τα ευαίσθητα δεδομένα σας προστατεύονται. Θα σας ζητηθεί το PIN σας κατά την πρόσβαση σε ασφαλισμένες ενότητες.',
        disabled: 'Η προστασία PIN είναι απενεργοποιημένη',
        disabledDescription: 'Ορίστε ένα PIN για να προστατέψετε ευαίσθητα τμήματα του λογαριασμού σας.',
    },
}
